import React, { useState } from "react";
const PageHeader = ({ title, text, customClassName }) => {
  return (
    <section className={`${customClassName ?? ""} page-header`}>
      <div className="page-content-controller mm-width">
        <h1 className="page-title">{title}</h1>
        <p className="page-intro-text">{text}</p>
      </div>
    </section>
  );
};

export default PageHeader;
